import { IFilterSelection } from './FilterDrawer';

export const dedupeSelections = (selections: { [key: string]: string }[]) =>
  selections.filter(
    (item, idx, arr) =>
      idx === arr.findIndex((t) => JSON.stringify(t) === JSON.stringify(item))
  );

export const buildFilterState = (
  allSelections: { [key: string]: string }[],
  dropdownConfigs: { searchKey: string }[]
): IFilterSelection =>
  dropdownConfigs.reduce(
    (acc, { searchKey }) => ({
      ...acc,
      [searchKey]: allSelections
        .filter((item) => Object.keys(item)[0] === searchKey)
        .map((item) => item[searchKey]),
    }),
    {} as IFilterSelection
  );
